import {Component, Inject, OnInit} from '@angular/core';
import {HazardsFilters} from "../../hazards/hazards-filter/hazards-filter.interface";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

@Component({
  selector: 'app-assets-view-hazards-filter',
  templateUrl: './assets-view-hazards-filter.component.html',
  styleUrls: ['./assets-view-hazards-filter.component.scss']
})
export class AssetsViewHazardsFilterComponent implements OnInit {
  filters: HazardsFilters = {
    status: '',
    archived: 'false'
  } as HazardsFilters;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssetsViewHazardsFilterComponent>
  ) { }

  ngOnInit() {
    // Set default values if not provided.
    this.filters.status = this.data['status'] || '';
    this.filters.archived = this.data['archived'] || 'false';
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.status = '';
    this.filters.archived = 'false';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    this.dialogRef.close(this.filters);
  }

  /**
   * Closes the dialog.
   *
   * @return {void}
   */
  onClose(): void {
    this.dialogRef.close();
  }
}
